import React, { ReactNode, useContext, useEffect, useState } from 'react';

import MissingToolMappingsContext from '@totem/components/salesOrders/missingToolMappings/MissingToolMappingsContext';
import { MissingToolMappingItems } from '@totem/components/salesOrders/missingToolMappings/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { SALES_ORDERS_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  children?: ReactNode;
};

const MissingToolMappingsContainer = ({ children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);

  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(true);
  const [reportData, setReportData] = useState<MissingToolMappingItems>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [searchText, setSearchText] = useState<string>('');

  useEffect(() => {
    if (!refreshData) {
      return;
    }

    setRefreshData(false);

    setLoading(true);

    fetch(`${SALES_ORDERS_ENDPOINT}/commissioning/missingToolMappings`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: MissingToolMappingItems) => {
        const data = result ?? [];
        setReportData(data);

        setTotalRecords(data.length);
      })
      .then(() => setLoading(false));
  }, [refreshData, getApiToken]);

  return (
    <MissingToolMappingsContext.Provider
      value={{
        loading,
        reportData,
        totalRecords,
        searchText,
        setSearchText,
        refetch: () => setRefreshData(true),
      }}
    >
      {children}
    </MissingToolMappingsContext.Provider>
  );
};

export default MissingToolMappingsContainer;
